var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7296 8.81081C13.6104 8.81081 15.135 7.28616 15.135 5.40541C15.135 3.52465 13.6104 2 11.7296 2C9.84887 2 8.32422 3.52465 8.32422 5.40541C8.32422 7.28616 9.84887 8.81081 11.7296 8.81081Z",
    stroke: "black",
    strokeOpacity: 0.44,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.0001C2 15.701 5.92059 12.2163 10.7568 12.2163M15.1351 20.4866L20 15.6217L18.0541 13.6758L13.1892 18.5406V20.4866H15.1351Z",
    stroke: "black",
    strokeOpacity: 0.44,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f1ac76d37845293500146ca066698f31.svg";
export { ForwardRef as ReactComponent };